import React from "react";
import ScroolTableAddPro from "./ScroolTableAddPro";
import { ProductConsumer } from "../../../Context/AddProWakel";
import _ from "lodash";

const AddProductSecond = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            edit,
            AddProChange,
            DarzanChange,
            darzan,
            updtae_product,
            Add_rasidkarton,
            del_dis,
            karton,
            onSaveTable,
            prodactdata,
            clear_edit,
            CartonChange,
            productpageminsone,
            productpageplusone,
            width,
            height,
            length,
            aynamictoanotherInput,
            meterPrice,
            metercheck,
            MeterTogler,
            MerterChange,
            remembiPrice,
            zhmarayDwkan,
            dnk,
            KoyGshtyR,
            KoyGshtydolar_,
            priceOneRRR,
            addnrxKraton,
            calculateNrxDarzan,
            kren,
            qazanj,
            nrxeFroshtnDolar,
            nrxifroshtnkarton,
            KM_onchangeSalePer,
            data,
            nsbayfrohtn,
            Chine_invoice,
            P_meterPrice,
            P_remembiPrice,
          } = value;
          return (
            <>
              <form>
                <div className="mt1">
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-3 text-right px-1 ">
                      <div className="row">
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">کاڵا- RR</label>
                            <input
                              type="text"
                               disabled={del_dis == true ? true : null}
                              value={
                                P_remembiPrice 
                              }
                              onChange={AddProChange}
                              name="P_remembiPrice"
                              className="form-control text-right f3 font-weight-bold bg-warning text-black"
                            />
                          </div>
                        </div>
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">
                             کاڵا-  مەتر
                            </label>
                            <input
                              type="text"
                               disabled={del_dis == true ? true : null}
                              value={P_meterPrice }
                              onChange={AddProChange}
                              name="P_meterPrice"
                              className="form-control text-right f3 font-weight-bold bg-warning text-black"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">ژ.پ.سین</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={Chine_invoice}
                          name="Chine_invoice"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 11, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-success text-white"
                        />
                      </div>
                    </div>

                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">ژ.دووکان</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={zhmarayDwkan}
                          name="zhmarayDwkan"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 3, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-success text-white"
                        />
                      </div>
                    </div>
                    <div className="col-3 text-right px-1 ">
                      <div className="row">
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">نرخی RR</label>
                            <input
                              type="text"
                              disabled={metercheck == false ? true : null}
                              onChange={(e) => AddProChange(e)}
                              value={ remembiPrice }
                              name="remembiPrice"
                              className="form-control text-right f3 font-weight-bold bg-success text-white"
                            />
                          </div>
                        </div>
                        <div className="col-6 text-right px-1">
                          <div className="form-group">
                            <label className="font-weight-bold">
                              نرخی مەتر
                            </label>
                            <input
                              type="text"
                              disabled={metercheck == false ? true : null}
                              onChange={(e) => AddProChange(e)}
                              onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 5, "p")
                              : null
                          }
                              value={meterPrice }
                              name="meterPrice"
                              className="form-control text-right f3 font-weight-bold bg-success text-white"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 mt4 text-right px-1 ">
                      {metercheck ? (
                        <button
                          onClick={MeterTogler}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-check"></i>
                        </button>
                      ) : (
                        <button
                          onClick={MeterTogler}
                          className="btn btn-primary"
                        >
                          <i className="fas fa-times-circle"></i>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1 ">
                      <div className="form-group">
                        <label className="font-weight-bold">$کۆی گشتی</label>
                        <input
                          type="text"
                          disabled={del_dis == true ? true : null}
                          value={Number(KoyGshtydolar_()).toFixed(2)}
                          name="length"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 5, "p")
                              : null
                          }
                          autoComplete="off"
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">Rکۆی گشتی</label>
                        <input
                          type="text"
                          value={Number(KoyGshtyR()).toFixed(2)}
                          name="techw"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 6, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          نرخی یەک دانە
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          name="priceOneRRR"
                          disabled={del_dis == true ? true : null}
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 15, "p")
                              : null
                          }
                          value={priceOneRRR}
                          onChange={AddProChange}
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">عدد کارتۆن</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={dnk}
                          name="dnk"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 10, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-secondary text-white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1 mt-5"></div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">تێچوی مەتر</label>
                        <input
                          type="text"
                          value={Number(MerterChange()).toFixed(2)}
                          name="techw"
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 16, "p")
                              : null
                          }
                          style={{ height: "45px" }}
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">پانی</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={width}
                          name="width"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 12, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">بەرزی</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={height}
                          name="height"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 13, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1 ">
                      <div className="form-group">
                        <label className="font-weight-bold">درێژی</label>
                        <input
                          type="text"
                          disabled={del_dis == true ? true : null}
                          onChange={(e) => AddProChange(e)}
                          value={length}
                          name="length"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 14, "p")
                              : null
                          }
                          autoComplete="off"
                          className="form-control text-right f3 font-weight-bold bg-info text-white"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row  f4" style={{ color: "#000C66" }}>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">٪فرۆشتن</label>
                        <input
                          type="text"
                          onChange={(e) => KM_onchangeSalePer(e, "nsbayfrohtn")}
                          value={nsbayfrohtn}
                          name="nsbayfrohtn"
                          style={{ height: "45px" }}
                           onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 17, "p")
                              : null
                          }
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">1 ك $$$$</label>
                        <input
                          type="text"
                          onChange={(e) => KM_onchangeSalePer(e, "qazanj")}
                          value={qazanj}
                          name="qazanj"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 16, "p")
                              : null
                          }
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          $ نرخی فرۆشتن
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            KM_onchangeSalePer(e, "nrxeFroshtnDolar")
                          }
                          value={nrxeFroshtnDolar}
                          name="nrxeFroshtnDolar"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 18, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">
                          {" "}
                          $ فرۆشتن کارتۆن
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            KM_onchangeSalePer(e, "nrxifroshtnkarton")
                          }
                          value={nrxifroshtnkarton}
                          name="nrxifroshtnkarton"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 19, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1">
                      <div className="form-group">
                        <label className="font-weight-bold">$$$</label>
                        <input
                          type="text"
                          onChange={(e) => AddProChange(e)}
                          value={kren}
                          name="kren"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 20, "p")
                              : null
                          }
                          autoComplete="off"
                          disabled={del_dis == true ? true : null}
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                    <div className="col-2 text-right px-1 ">
                      <div className="form-group">
                        <label className="font-weight-bold">نرخی کارتۆن</label>
                        <input
                          type="text"
                          disabled={del_dis == true ? true : null}
                          value={addnrxKraton}
                          onChange={calculateNrxDarzan}
                          name="addnrxKraton"
                          style={{ height: "45px" }}
                          onKeyPress={(event) =>
                            event.key == "Enter"
                              ? aynamictoanotherInput(event, 21, "p")
                              : null
                          }
                          autoComplete="off"
                          className="form-control text-right f3 font-weight-bold bg-danger text-white"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div className="mt5">
                <div className="row  f4" style={{ color: "#000C66" }}>
                  <div className="col-1 text-right px-2 mt4">
                    {edit == null ? (
                      <button
                        onClick={() => onSaveTable(prodactdata)}
                        className="btn btn-success"
                      >
                        <i className="far fa-save"></i>
                      </button>
                    ) : (
                      <button
                        onClick={() => updtae_product(edit._id)}
                        className="btn btn-primary"
                      >
                        <i className="far fa-edit"></i>
                      </button>
                    )}
                  </div>
                  <div className="col-2 text-right px-1">
                    <div className="form-group">
                      <label className="font-weight-bold">رەسید کارتۆن</label>
                      <input
                        type="text"
                        value={Add_rasidkarton}
                        name="Add_rasidkarton"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-2 text-right px-1 ">
                    <div className="form-group">
                      <label className="font-weight-bold">دەرزەن</label>
                      <input
                        type="text"
                        disabled={del_dis == true ? true : null}
                        onChange={(e) => DarzanChange(e)}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? edit == null
                              ? onSaveTable(event)
                              : updtae_product(edit._id)
                            : null
                        }
                        value={darzan}
                        name="darzan"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>

                  <div className="col-2 text-right px-1 ">
                    <div className="form-group">
                      <label className="font-weight-bold">کارتۆن</label>
                      <input
                        type="text"
                        disabled={del_dis == true ? true : null}
                        onChange={(e) => CartonChange(e)}
                        onKeyPress={(event) =>
                          event.key == "Enter"
                            ? edit == null
                              ? onSaveTable(event)
                              : updtae_product(edit._id, edit)
                            : null
                        }
                        value={karton}
                        name="karton"
                        className="form-control text-right font-weight-bold"
                      />
                    </div>
                  </div>
                  <div className="col-1 px-2 mt4">
                    {edit != null ? (
                      <button onClick={clear_edit} className="btn btn-primary">
                        <i className="fas fa-window-close"></i>
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-lg-2 col-4 px-2 mt4">
                    <button
                      className="btn btn-dark p3 px-4"
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                      onClick={productpageminsone}
                    >
                      <i className="fas fa-caret-left f4"></i>
                    </button>
                    <button
                      className="btn btn-dark p3 px-4 ml3"
                      style={{
                        backgroundColor: "#00695c",
                        border: "1px solid #00695c"
                      }}
                      onClick={productpageplusone}
                    >
                      <i className="fas fa-caret-right f4"></i>
                    </button>
                  </div>
                </div>
              </div>
              <ScroolTableAddPro />
              <div className="row px-2 tc">
                <div className="col-3"></div>
                <div className="col-3">
                  <label className="font-weight-bold">فرۆشتن</label>
                  <input
                    type="text"
                    value={Number(
                      _.subtract(
                        _.sumBy(data, function (o) {
                          return o.numberOfCarton;
                        }),
                        Add_rasidkarton
                      )
                    ).toFixed(2)}
                    className="form-control text-right font-weight-bold"
                  />
                </div>
                <div className="col-3">
                  <label className="font-weight-bold">کڕین</label>
                  <input
                    type="text"
                    value={Number(
                      _.sumBy(data, function (o) {
                        return o.numberOfCarton;
                      })
                    ).toFixed(2)}
                    className="form-control text-right font-weight-bold"
                  />
                </div>
                <div className="col-3"></div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default AddProductSecond;
